import React, { useState, useEffect, useCallback } from "react";
import { Card, Row, Col, InputNumber, Radio, Slider as AntSlider, Divider } from "antd";

import Slider from "../../components/slider";

//import multilanguage library
import { useTranslation } from "react-i18next";

// Styles
import { Label, FormItem, LabelUnit, LabelValue } from "./styles";

const INITIAL_STATE = {
  furnace: {
    temperature: 950,
    heating_ramp: 100,
    enabled_ramp: true,
    piece_temperrature: 35,
  },
  quenching: {
    bath_type: "water",
    bath_temperature: 50,
    agitation_level: 2,
  },
  tempered: {
    temperature: 600,
    enabled_ramp: true,
    heating_ramp: 100,
  },
};

const marksAgitation = {
  0: "0 m/s",
  1: "0.25 m/s",
  2: "0.50 m/s",
  3: "0.75 m/s",
};

const ConfigProcess = ({ article, handleChangeProcess, process }) => {
  const [state, setState] = useState(process || INITIAL_STATE);

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    if (handleChangeProcess && state) handleChangeProcess(state);
  }, [state, handleChangeProcess]);

  // Find in article the incomming key
  const RenderSlider = useCallback(
    ({ name, min, max, unit, findKey, id }) => {
      const value = state[findKey][id];
      const callback = (v) => {
        handleChange(v, findKey, id);
      };

      return slider({ name, min, max, unit, value, callback });
    },
    [state.articleName]
  );

  const slider = ({ name, min, max, value, unit, callback }) => {
    return <Slider name={name} min={min} max={max} unit={unit} value={value} callback={callback} />;
  };

  const handleChange = (value, findKey, id) => {
    const newState = Object.assign({}, state);
    newState[findKey][id] = value;
    setState(newState);
  };

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={8} lg={24}>
        <Card title={t("phase.furnace")}>
          <Col span={24}>
            <RenderSlider findKey="furnace" id="temperature" name={t("labels.furnace.furnace_temp")} min={850} max={1000} unit="ºC" />
          </Col>
          <Col span={24}>
            <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
              <Col>
                <FormItem>
                  <Label>{t("labels.furnace.initial_state")}</Label>
                </FormItem>
              </Col>
              <Col>
                <Radio.Group onChange={(el) => handleChange(el.target.value, "furnace", "enabled_ramp")} value={state.furnace.enabled_ramp}>
                  <Radio.Button value={false}>{t("labels.furnace.heat")}</Radio.Button>
                  <Radio.Button value={true}>{t("labels.furnace.cold")}</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row type="flex" align="middle" style={{ margin: 0 }}>
              <Col span={24}>
                <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
                  <Col>
                    <FormItem>
                      <Label>{t("labels.furnace.heating_ramp")}</Label>
                    </FormItem>
                  </Col>
                  <Col>
                    <InputNumber
                      disabled={!state.furnace.enabled_ramp}
                      min={50}
                      max={2000}
                      value={state.furnace.heating_ramp}
                      onChange={(v) => handleChange(v, "furnace", "heating_ramp")}
                      step={1}
                      style={{ verticalAlign: "middle", borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
                      /*formatter={value => `${value} mm`}*/
                    />
                    <div
                      className="ant-input-group-addon"
                      style={{ paddingTop: "2px", verticalAlign: "middle", display: "inline-table", lineHeight: "24px", height: "32px" }}
                    >
                      ºC/h
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <AntSlider
                  disabled={!state.furnace.enabled_ramp}
                  min={50}
                  max={2000}
                  tooltipVisible={false}
                  onChange={(v) => handleChange(v, "furnace", "heating_ramp")}
                  value={state.furnace.heating_ramp}
                />
              </Col>{" "}
            </Row>
          </Col>
          <Col span={24}>
            <RenderSlider findKey="furnace" id="piece_temperrature" name={t("labels.temperature_piece")} min={10} max={60} unit="ºC" />
          </Col>
        </Card>
      </Col>
      <Col xl={8} lg={24}>
        <Card title={t("phase.quenching")}>
          <Col span={24}>
            <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
              <Col>
                <FormItem>
                  <Label>{t("labels.quenching.bath_type.text")}</Label>
                </FormItem>
              </Col>
              <Col>
                <Radio.Group
                  onChange={(el) => handleChange(el.target.value, "quenching", "bath_type")}
                  defaultValue={state.quenching.bath_type}
                >
                  <Radio.Button value="water">{t("labels.quenching.bath_type.water")}</Radio.Button>
                  <Radio.Button value="oil">{t("labels.quenching.bath_type.oil")}</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <RenderSlider findKey="quenching" id="bath_temperature" name={t("labels.quenching.bath_temp")} min={40} max={100} unit="ªC" />
          </Col>
          <Col span={24}>
            <Row type="flex" align="middle" style={{ margin: 0 }}>
              <Col span={24}>
                <FormItem>
                  <Label>{t("labels.quenching.agitation_level")}</Label>
                </FormItem>
                <AntSlider
                  marks={marksAgitation}
                  min={0}
                  max={3}
                  value={state.quenching.agitation_level}
                  onChange={(v) => handleChange(v, "quenching", "agitation_level")}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Divider style={{ fontSize: 12, fontWeight: "normal" }}>{t("labels.variables_of", { value: article.name })}</Divider>
            <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
              <Col>
                <FormItem>
                  <Label>{t("labels.tempered_coat")}</Label>
                </FormItem>
              </Col>
              <Col>
                <LabelValue>{article ? article.hard_coat : 0} </LabelValue>
                <LabelUnit>mm</LabelUnit>
              </Col>
            </Row>
          </Col>
        </Card>
      </Col>
      <Col xl={8} lg={24}>
        <Card title={t("phase.tempered")}>
          <Col span={24}>
            <RenderSlider findKey="tempered" id="temperature" name={t("labels.furnace.furnace_temp")} min={200} max={700} unit="ºC" />
          </Col>
          <Col span={24}>
            <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
              <Col>
                <FormItem>
                  <Label>{t("labels.furnace.initial_state")}</Label>
                </FormItem>
              </Col>
              <Col>
                <Radio.Group
                  onChange={(el) => handleChange(el.target.value, "tempered", "enabled_ramp")}
                  defaultValue={state.tempered.enabled_ramp}
                >
                  <Radio.Button value={false}>{t("labels.furnace.heat")}</Radio.Button>
                  <Radio.Button value={true}>{t("labels.furnace.cold")}</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row type="flex" align="middle" style={{ margin: 0 }}>
              <Col span={24}>
                <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
                  <Col>
                    <FormItem>
                      <Label>{t("labels.furnace.heating_ramp")}</Label>{" "}
                    </FormItem>
                  </Col>
                  <Col>
                    <InputNumber
                      disabled={!state.tempered.enabled_ramp}
                      min={50}
                      max={2000}
                      value={state.tempered.heating_ramp}
                      onChange={(v) => handleChange(v, "tempered", "heating_ramp")}
                      step={1}
                      style={{ verticalAlign: "middle", borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
                      /*formatter={value => `${value} mm`}*/
                    />
                    <div
                      className="ant-input-group-addon"
                      style={{ paddingTop: "2px", verticalAlign: "middle", display: "inline-table", lineHeight: "24px", height: "32px" }}
                    >
                      ºC/h
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <AntSlider
                  disabled={!state.tempered.enabled_ramp}
                  min={50}
                  max={2000}
                  tooltipVisible={false}
                  onChange={(v) => handleChange(v, "tempered", "heating_ramp")}
                  value={state.tempered.heating_ramp}
                />
              </Col>{" "}
            </Row>
          </Col>
          <Col span={24}>
            <Divider style={{ fontSize: 12, fontWeight: "normal" }}>{t("labels.variables_of", { value: article.name })}</Divider>
            <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
              <Col>
                <FormItem>
                  <Label>{t("labels.hardness_required")}</Label>
                </FormItem>
              </Col>
              <Col>
                <LabelValue>{article ? article.hardness_required : 0} </LabelValue>
                <LabelUnit>HV1</LabelUnit>
              </Col>
            </Row>
          </Col>
        </Card>
      </Col>
    </Row>
  );
};

export default ConfigProcess;
